import React from 'react';
import { Link } from 'react-router-dom';
import { SOURCE_TYPE_LABELS } from '../constants';

function KnowledgeBaseNameCell({ kb, showSubtitle = true }) {
  const sourceLabel = SOURCE_TYPE_LABELS[kb.source_type] || kb.source_type;
  const subtitle = sourceLabel;

  return (
    <div className="min-w-0">
      <Link
        to={`/knowledge-bases/${kb.id}`}
        className="font-medium text-forge-700 hover:text-forge-900 hover:underline truncate block"
        title={kb.name}
      >
        {kb.name}
      </Link>
      {showSubtitle && (
        <p className="text-xs text-content-subtle mt-0.5 truncate" title={subtitle}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export default KnowledgeBaseNameCell;
